import { Box, Card, CircularProgress, Skeleton } from '@mui/material';
import { StyledCardContent } from './styles';
import { CARD_DIMENSIONS } from '@/constants/layout';

interface LoadingCardProps {
  onClick?: () => void;
}

const LoadingCard = ({ onClick }: LoadingCardProps) => {
  return (
    <Card sx={{ width: '100%', height: CARD_DIMENSIONS.HEIGHT, position: 'relative' }} onClick={onClick}>
      <Box
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <CircularProgress size={65} thickness={3} sx={{ color: '#03A9F4' }} />
      </Box>
      <Skeleton variant="rectangular" width="100%" height={CARD_DIMENSIONS.THUMBNAIL_HEIGHT} />
      <StyledCardContent>
        <Skeleton height={20} />
        <Skeleton height={30} width="80%" />
        <Skeleton height={20} width="60%" />
      </StyledCardContent>
    </Card>
  );
};

export default LoadingCard;
